import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const rankingHorizontalBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'number', required: true },
    { field: 'y', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'ranking-horizontal-bar-sufficient-data',
      validator: data => data.length > 1,
      message: 'Ranking horizontal bar chart requires more than 1 data point',
      suggestion: 'Provide multiple data points for meaningful ranking visualization',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'ranking-horizontal-bar-x-diversity',
      validator: (data, layer) => {
        const { encoding } = layer;
        const xValues = new Set(data.map(item => item[encoding?.x as string]));
        return xValues.size > 1;
      },
      message: 'Ranking horizontal bar chart requires diverse x-field values',
      suggestion: 'Provide different numerical values in the x field for ranking comparison',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'ranking-horizontal-bar-sufficient-categories',
      validator: (data, layer) => {
        const { encoding } = layer;
        const yValues = new Set(data.map(item => item[encoding?.y as string]));
        return yValues.size > 3;
      },
      message:
        'Ranking horizontal bar chart requires more than 3 categories for meaningful ranking',
      suggestion:
        'Provide at least 4 different categories in the y field for effective ranking visualization',
      // 关键功能错误，影响图表渲染
      severity: 'error'
    },
    {
      name: 'ranking-horizontal-bar-optimal-count',
      validator: data => data.length <= 20,
      message: 'Ranking horizontal bar chart works best with 20 or fewer items',
      suggestion: 'Consider limiting to top 20 items or using pagination for better readability',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
